import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  Routes,
  Route,
} from "react-router-dom";
import AttendancePage from "../pages/AttendancePage";
import Navbar from "./common/Navbar";
import "../Assets/CSS/Layouts.css"; // Import custom CSS
// import { Icon } from "@iconify/react/dist/iconify.js";
import { Icon } from "@iconify/react";
import { jwtDecode } from "jwt-decode";

export const getUserRole = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT:", decoded);

    const roles = decoded.roles || []; // roles array from token
    const userName = decoded.userName || decoded.sub || null; // subject claim

    // Expiration (exp is in seconds, convert to ms)
    const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

    return { roles, userName, expiryTime };
  } catch (error) {
    console.error("Invalid token", error);
    return { roles: [], userName: null, expiryTime: null };
  }
};
const Layout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { roles = [] } = getUserRole(token); // default to empty array
  // Check if user is on Onboarding Profile page

  const getOffboardingLabel = (roles) => {
    if (roles.includes("ROLE_ADMIN")) return "Admin Offboarding";
    if (roles.includes("ROLE_HR")) return "HR Offboarding";
    if (roles.includes("ROLE_MANAGER")) return "Manager Offboarding";
    if (roles.includes("ROLE_EMP")) return "Employee Offboarding";
    if (roles.includes("ROLE_FINANCE")) return "Offboarding";
    if (roles.includes("ROLE_IT_MANAGER")) return "Offboarding";
    return "Offboarding";
  };

  const menus = [

    {
      label: "Dashboard",
      icon: "mage:dashboard",
      activeIcon: "mage:dashboard-fill",
      link:
        roles.includes("ROLE_ADMIN") ||
          roles.includes("ROLE_HR") ||
          roles.includes("ROLE_IT_MANAGER") ||
          roles.includes("ROLE_FINANCE") ||
          roles.includes("ROLE_SYSTEM_ADMIN")

          ? "/admin-dashboard"
          : "/employee-dashboard",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_EMP") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_FINANCE") ||
        roles.includes("ROLE_SYSTEM_ADMIN"),
    },

    {
      label: "My Dashboard",
      icon: "material-symbols:event-outline-rounded",
      activeIcon: "material-symbols:event",
      link: "/employee-dashboard",
      visible:

        roles.includes("ROLE_ADMIN")

    },


    {
      label: "Employee's Timesheet",
      icon: "solar:sort-by-time-linear",
      activeIcon: "solar:sort-by-time-bold",
      link:
        roles.includes("ROLE_ADMIN") ||
          roles.includes("ROLE_MANAGER") ||
          roles.includes("ROLE_HR") ||
          roles.includes("ROLE_IT_MANAGER") ||
          roles.includes("ROLE_FINANCE") ||
          roles.includes("ROLE_SYSTEM_ADMIN")
          ? "/admin-timesheet"
          : "/timesheet",
      visible:
        roles.includes("ROLE_ADMIN") ||

        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_FINANCE") ||
        roles.includes("ROLE_SYSTEM_ADMIN"),
    },

    {
      label: "My Timesheet",
      icon: "solar:sort-by-time-linear",
      activeIcon: "solar:sort-by-time-bold",
      link:
        roles.includes("ROLE_MANAGER") || roles.includes("ROLE_EMP") || roles.includes("ROLE_ADMIN")
          ? "/timesheet"
          : "/timesheet",
      visible: roles.includes("ROLE_EMP") || roles.includes("ROLE_MANAGER") || roles.includes("ROLE_ADMIN"),
    },

    {
      label: "Leave Management",
      icon: "material-symbols:event-outline-rounded",
      activeIcon: "material-symbols:event",
      link: "/leave-management",
      visible:
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_EMP") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_FINANCE") ||
        roles.includes("ROLE_SYSTEM_ADMIN")
    },
    {
      label: "Mail Generate",
      icon: "material-symbols:event-outline-rounded",
      activeIcon: "material-symbols:event",
      link: "/mail-generate",
      visible:
        roles.includes("ROLE_IT_MANAGER")

    },
    ...(roles.includes("ROLE_ADMIN")
      ? [
        {
          label: "Employee Manager",
          icon: "material-symbols:group-outline",
          activeIcon: "material-symbols:group",
          link: "/emp-management",
          visible:
            roles.includes("ROLE_ADMIN") ||
            roles.includes("ROLE_MANAGER") ||
            roles.includes("ROLE_HR") ||
            roles.includes("ROLE_IT_MANAGER") ||
            roles.includes("ROLE_FINANCE") ||
            roles.includes("ROLE_SYSTEM_ADMIN")
        },
      ]
      : []),
    {
      label: "Employee Onboarding",
      icon: "material-symbols:person-add-outline",
      activeIcon: "material-symbols:person-add",
      link: "/emp-onbaord",
      visible: roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_FINANCE"),
    },

    {
      label: "Appointment Status",
      icon: "material-symbols:person-add-outline",
      activeIcon: "material-symbols:person-add",
      link: "/onboardAppoint-approve", // since both conditions are the same
      visible: roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_FINANCE"), // show only for admin
    },
    {
      label: "Company Master",
      icon: "material-symbols:person-add-outline",
      activeIcon: "material-symbols:person-add",
      link: "/company-maslist", // since both conditions are the same
      visible: roles.includes("ROLE_ADMIN")
    },
    {
      label: "Department & Role",
      icon: "mingcute:department-line",
      activeIcon: "mingcute:department-fill",
      link: "/deptrole", // since both conditions are the same
      visible: roles.includes("ROLE_ADMIN") || roles.includes("ROLE_SYSTEM_ADMIN"), // show only for admin
    },
    {
      label: "Tenant Management",
      icon: "mingcute:department-line",
      activeIcon: "mingcute:department-fill",
      link: "/tenent", // since both conditions are the same
      visible: roles.includes("ROLE_SYSTEM_ADMIN"), // show only for admin
    },
    {
      label: "CMS",
      icon: "material-symbols-light:content-copy-rounded",
      activeIcon: "mingcute:department-fill",
      link: "/annexure-salary", // since both conditions are the same
      visible: roles.includes("ROLE_ADMIN"), // show only for admin
    },
    {
      label: "Invoice",
      icon: "material-symbols-light:content-copy-rounded",
      activeIcon: "mingcute:department-fill",
      link: "/list-invoice", // since both conditions are the same
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_FINANCE")
      , // show only for admin
    },
    {
      label: "Work Order",
      icon: "material-symbols-light:content-copy-rounded",
      activeIcon: "mingcute:department-fill",
      link: "/work-orderlist", // since both conditions are the same
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_FINANCE")
      , // show only for admin
    },
    {
      label: "Offboarding",
      icon: "material-symbols:person-remove",
      activeIcon: "material-symbols:person-remove",
      link: "/off-boarding", // since both conditions are the same
      visible: roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_FINANCE") ||
        roles.includes("ROLE_IT_MANAGER"),
    },
    {
      label: "Employee Offboarding",
      icon: "material-symbols:person-remove",
      activeIcon: "material-symbols:person-remove",
      link: "/off-boarding-employee", // since both conditions are the same
      visible: roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_FINANCE") ||
        roles.includes("ROLE_IT_MANAGER") ||
        roles.includes("ROLE_EMP"),
    },
    //     {
    //   label: getOffboardingLabel(roles),
    //   icon: "material-symbols:person-remove",
    //   activeIcon: "material-symbols:person-remove",
    //   link: "/off-boarding",
    //   visible:
    // roles.includes("ROLE_ADMIN") ||
    // roles.includes("ROLE_HR") ||
    // roles.includes("ROLE_MANAGER") ||
    // roles.includes("ROLE_EMP") ||
    // roles.includes("ROLE_FINANCE") ||
    // roles.includes("ROLE_IT_MANAGER") ,


    // },

    {
      label: "Offboarding Configuration",
      icon: "material-symbols:settings",
      activeIcon: "material-symbols:settings",
      link: "/off-boarding-config", // since both conditions are the same
      visible: roles.includes("ROLE_ADMIN"), // show only for admin
    },
    // {
    //   label: "Project Tracking",
    //   icon: "material-symbols:business-center",
    //   activeIcon: "material-symbols:business-center",
    //   link: "/projectdashboard", // since both conditions are the same
    //   visible: roles.includes("ROLE_ADMIN"), // show only for admin
    // },
    {
      label: "Team CMS",
      icon: "material-symbols:business-center",
      activeIcon: "material-symbols:business-center",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_EMP") ||
        roles.includes("ROLE_SYSTEM_ADMIN"),
      children: [
        {
          label: "Task Tracking",
          link: "/mytask",
          visible:
            roles.includes("ROLE_EMP") ||
            roles.includes("ROLE_MANAGER") ||
            roles.includes("ROLE_ADMIN") ||
            roles.includes("ROLE_SYSTEM_ADMIN"),
        },
        {
          label: "Project Tracking",
          link: "/projectdashboard",
          visible:
            roles.includes("ROLE_MANAGER") ||
            roles.includes("ROLE_ADMIN") ||
            roles.includes("ROLE_SYSTEM_ADMIN"),

        },
        {
          label: "Team CMS",
          link: "/teamList",
          visible: roles.includes("ROLE_MANAGER") ||
            roles.includes("ROLE_ADMIN") ||
            roles.includes("ROLE_SYSTEM_ADMIN")
          ,

        },
      ],
    },
  ];

  useEffect(() => {
    if (isLoggedOut) {
      navigate("/");
    }
  }, [isLoggedOut, navigate]);

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };
  useEffect(() => {
    menus.forEach((menu, index) => {
      if (menu.children) {
        const isChildActive = menu.children.some((child) =>
          location.pathname.startsWith(child.link)
        );
        if (isChildActive) {
          setOpenDropdown(index);
        }
      }
    });
  }, [location.pathname]);

  const isParentActive = (menu) => {
    if (!menu.children) return false;
    return menu.children.some((child) =>
      location.pathname.startsWith(child.link)
    );
  };

  return (
    <div className="layout-wrapper" style={{ overflow: "auto" }}>
      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}
        style={{
          height: "100vh",
          overflowY: "auto",
          overflowX: "hidden",

          top: 0,
        }}
      >
        {/* <ul className="menu-list ">
          {menus.map(
            (menu, index) =>
              menu.visible !== false && (
                <li key={index} className="my-2">
                  <Link
                    to={menu.link}
                    className={`menu-item menus-btn  ${
                      location.pathname === menu.link ? "active" : ""
                    }`}
                  >
                    <Icon
                      icon={
                        location.pathname === menu.link && menu.activeIcon
                          ? menu.activeIcon
                          : menu.icon
                      }
                      className="me-2 fs-5"
                    />
                    {!isSidebarCollapsed && (
                      <span className="menu-label ">{menu.label}</span>
                    )}
                  </Link>
                </li>
              )
          )}
        </ul> */}

        <ul className="menu-list">
          {menus.map(
            (menu, index) =>
              menu.visible !== false && (
                <li key={index} className="my-2">
                  {/* Parent Menu */}
                  {menu.children ? (
                    <>
                      <div
                        className={`menu-item menus-btn d-flex align-items-center justify-content-between ${isParentActive(menu) ? "active" : ""
                          }`}
                        onClick={() => toggleDropdown(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center">
                          <Icon icon={menu.icon} className="me-2 fs-5" />
                          {!isSidebarCollapsed && (
                            <span className="menu-label">{menu.label}</span>
                          )}
                        </div>

                        {!isSidebarCollapsed && (
                          <Icon
                            icon={
                              openDropdown === index
                                ? "mdi:chevron-up"
                                : "mdi:chevron-down"
                            }
                          />
                        )}
                      </div>

                      {/* Dropdown */}
                      {openDropdown === index && !isSidebarCollapsed && (
                        <div
                          className="submenu-wrapper "
                          style={{
                            backgroundColor: "#AFEAFF",
                            borderRadius: "18px",
                            padding: "8px 12px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
                            transition: "all 0.3s ease",
                          }}
                        >
                          <ul className="submenu">
                            { /*
                            {menu.children.map((child, i) => (
                              <li key={i}>
                                <Link
                                  to={child.link}
                                  className={`submenu-item ${location.pathname.startsWith(child.link)
                                    ? "active"
                                    : ""
                                    }`}
                                >
                                  {child.label}
                                </Link>
                              </li>
                            ))}
                            */}
                            {menu.children.map((child, i) =>
                              child.visible ? (
                                <li key={i}>
                                  <Link
                                    to={child.link}
                                    className={`submenu-item ${location.pathname.startsWith(child.link)
                                      ? "active"
                                      : ""
                                      }`}
                                  >
                                    {child.label}
                                  </Link>
                                </li>
                              ) : null
                            )}
                          </ul>
                        </div>
                      )}
                    </>
                  ) : (
                    /* Normal Menu */
                    <Link
                      to={menu.link}
                      className={`menu-item menus-btn ${location.pathname === menu.link ? "active" : ""
                        }`}
                    >
                      <Icon
                        icon={
                          location.pathname === menu.link && menu.activeIcon
                            ? menu.activeIcon
                            : menu.icon
                        }
                        className="me-2 fs-5"
                      />
                      {!isSidebarCollapsed && (
                        <span className="menu-label">{menu.label}</span>
                      )}
                    </Link>
                  )}
                </li>
              )
          )}
        </ul>
      </aside>

      {/* Main Content */}
      <main className={`main-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <Navbar />
        <div className="page-content">
          <Routes>
            <Route path="/time-sheet" element={<AttendancePage />} />
            <Route path="*" element={children} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Layout;
